import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const AdditionalSLALogRolesRBAC = {
  pageID: '66ab7f1dc1757277b806e89c79504db4',
  elementID: {
    ViewPage: 'f17b03ced265995a4523af949eee7145',
    EditSLA: '5b6c0ac15c863e95b281adea23afb026',
    AddSLA: 'f4c63ba3ce7c09eff2c74d57163a1b39',
  },
} as const

export const useRBACAdditionalSLALogPage = createUseRBAC(AdditionalSLALogRolesRBAC.elementID)

export type UseRBACAdditionalSLALogPageType = ReturnType<typeof useRBACAdditionalSLALogPage>
